import { render, staticRenderFns } from "./supplier_report_statuses.vue?vue&type=template&id=288958d0&scoped=true&"
import script from "./supplier_report_statuses.vue?vue&type=script&lang=js&"
export * from "./supplier_report_statuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288958d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('288958d0')) {
      api.createRecord('288958d0', component.options)
    } else {
      api.reload('288958d0', component.options)
    }
    module.hot.accept("./supplier_report_statuses.vue?vue&type=template&id=288958d0&scoped=true&", function () {
      api.rerender('288958d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/supplier_report_statuses.vue"
export default component.exports